var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllpingsDec(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 36,
    viewBox: "0 0 39 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.80078 1.6875L12.4356 13.3668L16.9753 8.37387L35.1973 28.3981",
    stroke: "#FF004F",
    strokeWidth: 3.33445,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2188 28.3979H36.312V19.4966",
    stroke: "#FF004F",
    strokeWidth: 3.55682,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17188 21.2838V35.5297",
    stroke: "white",
    strokeWidth: 3.55682,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2656 17.7092V35.5306",
    stroke: "white",
    strokeWidth: 3.55682,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3516 23.0538V35.5306",
    stroke: "white",
    strokeWidth: 3.55682,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllpingsDec);
export default __webpack_public_path__ + "static/media/allpings_dec.0682036f990098423c88c12efc2759b7.svg";
export { ForwardRef as ReactComponent };